import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from "axios";
import { SEARCH_FACET_DISPLAY_ID_RATING, SEARCH_FACET_TYPE_NESTED, SEARCH_FACET_TYPE_RANGE } from "@search-app/helpers/search/search.helpers.facets";
import randomString from "@search-app/utilities/search/search.utilities.randomString";
import { isTacticalCategoryPage } from "@search-app/utilities/tacticalCategory";
import { getPathname } from "@search-app/utilities/url"; // Identified to group search requests

var sessionId = randomString(16); // Number of search requests made, incremented on each search request

var sequence = 1; // Could use a strict union type here

export function searchProducts(_x) {
  return _searchProducts.apply(this, arguments);
}
/**
 * Gets the base url for search depending on the current page.
 *
 * Search: /search.json
 * Brand/Shop: /<currentPath>/search.json
 */

function _searchProducts() {
  _searchProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _response$data;

    var query, baseUrl, queryString, url, response, redirectUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query;
            baseUrl = searchBaseUrl();
            queryString = "".concat(query.length ? "".concat(query, "&") : "", "ssid=").concat(sessionId, "&sseq=").concat(sequence);
            sequence++;
            url = queryString ? "".concat(baseUrl, "?").concat(queryString.replace(/^\?/, "")) : baseUrl;
            _context.next = 7;
            return axios.get(url);

          case 7:
            response = _context.sent;
            // If search.json returns a redirect_url in the payload, redirect to that URL
            redirectUrl = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.redirect_url;

            if (!redirectUrl) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", {
              redirectUrl: redirectUrl
            });

          case 11:
            return _context.abrupt("return", response.data);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _searchProducts.apply(this, arguments);
}

export function searchBaseUrl() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getPathname();
  var searchEndpoint = "/search.json";

  if (!pathname) {
    return searchEndpoint;
  } // Customer Category page


  if (pathname.startsWith("/category")) {
    // Omit '/browse' from tactical category pages so that the results stay the same
    if (isTacticalCategoryPage(pathname)) {
      return "".concat(pathname.replace(/\/browse\/?$/, "")).concat(searchEndpoint);
    }

    return "".concat(pathname.replace(/\/$/, "")).concat(searchEndpoint);
  } // Search Pages, /search


  if (pathname === "search") {
    return searchEndpoint;
  } // Shop pages with filter-groups of the form, /shop/<name>/filter-group/<category>/search


  if (pathname.endsWith("/search")) {
    return "".concat(pathname.replace(/\/search$/, "")).concat(searchEndpoint);
  } // Seller pages of the form /seller/<name>/products.html


  if (pathname.endsWith("/products.html")) {
    return "".concat(pathname.replace(/products\.html$/, "products.json"));
  } // All other pages: brand pages, seller pages. Just append /search.json


  return "".concat(pathname.replace(/\/$/, "")).concat(searchEndpoint);
}
export function appliedFacetsToQueryObject(appliedFacets, facet, value, type) {
  var queryObject = appliedFacets.reduce(function (acc, appliedFacet) {
    if (acc[appliedFacet.facetName]) {
      acc[appliedFacet.facetName].push(appliedFacet.id);
    } else {
      acc[appliedFacet.facetName] = [appliedFacet.id];
    }

    return acc;
  }, {});

  if (typeof value === "string") {
    // Facet doesn't exist in query object, so add it
    if (!queryObject[facet]) {
      queryObject[facet] = [value];
      return queryObject;
    } // Facet does exist so we want to toggle if off by removing it


    if (queryObject[facet].includes(value)) {
      queryObject[facet].splice(queryObject[facet].indexOf(value), 1);
      return queryObject;
    } // Nested type and Ratings only have one value at a time, so we overwrite it


    if (type === SEARCH_FACET_TYPE_NESTED || facet === SEARCH_FACET_DISPLAY_ID_RATING) {
      queryObject[facet] = [value];
      return queryObject;
    } // All other values can have multiple values, so we add it


    queryObject[facet].push(value);
    return queryObject;
  }

  if (type === SEARCH_FACET_TYPE_RANGE && Array.isArray(value)) {
    // Range is a special case, we delete the default value and and two new ones for min and max
    delete queryObject[facet];

    var _value = _slicedToArray(value, 2),
        min = _value[0],
        max = _value[1];

    queryObject["".concat(facet, ":min")] = ["".concat(min)];
    queryObject["".concat(facet, ":max")] = ["".concat(max)];
    return queryObject;
  }

  return queryObject;
}